import request from "@/utils/request";

export function getMorkhasiInfo() {
  return request({
    url: "morkhasi/data",
    method: "post",
  });
}

export function requestMorkhasi(
  file,
  startDate,
  endDate,
  MorkhasiType,
  comment
) {
  let fileName = file == null ? "" : file.name;
  var fmData = new FormData();
  fmData.append("StartDate", startDate);
  fmData.append("EndDate", endDate);
  fmData.append("MorkhasiCycle", MorkhasiType);
  fmData.append("Comment", comment);
  fmData.append("image", file);
  fmData.append("fileName", fileName);


  return request({
    url: "morkhasi/save",
    method: "post",
    data: fmData,
  });
}
export function getMorkhasiHistory() {
  return request({
    url: "morkhasi/gethistory",
    method: "post",
  });
}

export function removeMorkhasiRequest(requestID, srlFile) {
  return request({
    url: "morkhasi/remove",
    method: "post",
    data: {
      requestID: requestID,
      FileID: srlFile,
    },
  });
}

export function downloadAttach(requestID, token) {
  return request({
    url: "/morkhasi/downloadattach",
    method: "post",

    data: { RequestID: requestID, HashToken: token },
  });
}
